
function About() {
  return (
    <section id="about" className="py-16 px-4 max-w-4xl mx-auto reveal" aria-labelledby="about-title" style={{ transitionDelay: '0.06s' }}>
      <h2 id="about-title" className="text-3xl font-bold mb-8 text-center">About Me</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <p className="text-lg leading-relaxed">
          Front-End Developer specializing in React and modern JavaScript. I build responsive web applications with a focus on user experience, performance, and clean architecture.
        </p>
        <p className="text-lg leading-relaxed">
          Recently developed a full dashboard application with analytics and real-time data handling.
        </p>
      </div>
    </section>
  );
}

export default About;